import request from '@/utils/request'
import { appCode } from '@/utils/dictionaries'

/**
 * 【人脸库】列表
 * @param {object} parameter
 */
export function listAiFaceLibrary (parameter) {
  return request({
    url: '/ai-meeting/sys/AiFaceLibrary/listAiFaceLibrary',
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【班前会重复计划】列表
 * @param {object} parameter
 */
export function listAiMeetingPlan (parameter) {
    return request({
      url: '/ai-meeting/sys/AiMeetingPlan/listAiMeetingPlan',
      method: 'get',
      params: { ...parameter, appCode }
    })
  }

/**
 * 【班前会重复计划】新增
 * @param {object} parameter
 */
export function saveAiMeetingPlan (parameter) {
  return request({
    url: '/ai-meeting/sys/AiMeetingPlan/saveAiMeetingPlan',
    method: 'post',
    data: { ...parameter, appCode }
  })
}
/**
 * 【班前会重复计划】编辑
 * @param {object} parameter
 */
export function updateAiMeetingPlan (parameter) {
  return request({
    url: '/ai-meeting/sys/AiMeetingPlan/updateAiMeetingPlan',
    method: 'put',
    data: { ...parameter, appCode }
  })
}
/**
 * 【班前会重复计划】启用/禁用
 * @param {object} parameter
 */
export function updateAiMeetingPlanStatus (parameter) {
  return request({
    url: '/ai-meeting/sys/AiMeetingPlan/updateAiMeetingPlanStatus',
    method: 'put',
    data: { ...parameter, appCode }
  })
}
/**
 * 【班前会重复计划】删除
 * @param {object} parameter
 */
export function deleteAiMeetingPlan (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlan/deleteAiMeetingPlanById/${parameter.id}`,
    method: 'delete'
  })
}
/**
 * 【班前会重复计划】查看
 * @param {object} parameter
 */
export function getAiMeetingPlanById (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlan/getAiMeetingPlanById/${parameter.id}`,
    method: 'get'
  })
}
/**
 * 【班前会识别记录】列表
 * @param {object} parameter
 */
export function listAiFaceRecognitionLog (parameter) {
  return request({
    url: `/ai-meeting/sys/AiFaceRecognitionLog/listAiFaceRecognitionLog`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【班前会预约】列表
 * @param {object} parameter
 */
export function listAiMeeting (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeeting/listAiMeeting`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【班前会预约】新增
 * @param {object} parameter
 */
export function saveAiMeeting (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeeting/saveAiMeeting`,
    method: 'post',
    data: { ...parameter, appCode }
  })
}
/**
 * 【班前会预约】修改
 * @param {object} parameter
 */
export function updateAiMeeting (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeeting/updateAiMeeting`,
    method: 'put',
    data: { ...parameter, appCode }
  })
}
/**
 * 【班前会预约】删除
 * @param {object} parameter
 */
export function deleteAiMeetingById (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeeting/deleteAiMeetingById/${parameter.id}`,
    method: 'delete'
  })
}
/**
 * 【班前会预约】查看
 * @param {object} parameter
 */
export function getAiMeetingById (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeeting/getAiMeetingById/${parameter.id}`,
    method: 'get'
  })
}
/**
 * 【班前会配置】列表
 * @param {object} parameter
 */
export function listAiMeetingPlaceConfig (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlaceConfig/listAiMeetingPlaceConfig`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【班前会配置】删除
 * @param {object} parameter
 */
export function deleteAiMeetingPlaceConfigById (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlaceConfig/deleteAiMeetingPlaceConfigById/${parameter.id}`,
    method: 'delete'
  })
}
/**
 * 【班前会配置】保存
 * @param {object} parameter
 */
export function saveAiMeetingPlaceConfig (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlaceConfig/saveAiMeetingPlaceConfig`,
    method: 'post',
    data: { ...parameter, appCode }
  })
}
/**
 * 【班前会配置】修改
 * @param {object} parameter
 */
export function updateAiMeetingPlaceConfig (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlaceConfig/updateAiMeetingPlaceConfig`,
    method: 'put',
    data: { ...parameter, appCode }
  })
}
/**
 * 【班前会配置】查看
 * @param {object} parameter
 */
export function getAiMeetingPlaceConfigById (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlaceConfig/getAiMeetingPlaceConfigById/${parameter.id}`,
    method: 'get'
  })
}
/**
 * 【班前会配置】关联设备列表
 * @param {object} parameter
 */
export function listMonitoring (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlaceConfig/listMonitoring`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【账号管理】获取班组列表
 * @param {object} parameter
 */
export function listTeams (parameter) {
  return request({
    url: `/ai-meeting/sys/userApi/ListTeams/${parameter.orgId}`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【账号管理】获取班组下人员
 * @param {object} parameter
 */
export function listTeamsUser (parameter) {
  return request({
    url: `/ai-meeting/sys/userApi/ListTeamsUser/${parameter.orgId}/${parameter.teamId}`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}

/**
 * 【班前会台账】列表
 * @param {object} parameter
 */
export function listAiMeetingAccount (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingRecord/listAiMeetingRecord`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【班前会台账】新增/编辑
 * @param {object} parameter
 */
export function saveAiMeetingRecord (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingRecord/saveAiMeetingRecord`,
    method: 'post',
    data: { ...parameter, appCode }
  })
}
/**
 * 【班前会台账】删除
 * @param {object} parameter
 */
export function deleteAiMeetingRecordById (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingRecord/deleteAiMeetingRecordById/${parameter.id}`,
    method: 'delete'
  })
}
/**
 * 【班前会台账】查看
 * @param {object} parameter
 */
export function getAiMeetingRecordById (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingRecord/getAiMeetingRecordById/${parameter.id}`,
    method: 'get'
  })
}
/**
 * 【班前会台账】 参会情况饼图
 * @param {object} parameter
 */
export function participationSituation (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingRecord/participationSituation/${parameter.id}`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【班前会台账】 参会人员列表
 * @param {object} parameter
 */
export function listMeetingAttendee (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingRecord/listMeetingAttendee`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【班前会台账】 截取视频
 * @param {object} parameter
 */
export function videoCapture (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingRecord/videoCapture`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
/**
 * 【班前会台账】 预览截取视频
 * @param {object} parameter
 */
export function getVideoAddress (parameter) {
  return request({
    url: `/ai-meeting/sys/AiMeetingPlaceConfig/getVideoAddress`,
    method: 'get',
    params: { ...parameter, appCode }
  })
}
